import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AttatchedFile from './IconBlock/AttatchedFile';
import ChildrenTask from './IconBlock/ChildrenTask';
import CloseRequest from './IconBlock/CloseRequest';
import ParentTask from './IconBlock/ParentTask';
import { axiosPath, path } from '../../../../../../routing/helpers/router';
import Actions from './IconBlock/Actions';

export default function IconListBlock(props) {
  const { taskID } = props;
  const { moduleBridgeHex, view } = useParams();
  const navigate = useNavigate();
  const level1 = useSelector((state) => state.currentPage?.levels?.level1);
  const level2 = useSelector((state) => state.currentPage?.levels?.level2);

  const goToEvaluation = useCallback(
    (hexCode) =>
      navigate(
        path({
          name: 'user_module_correctiveActions_task_list',
          params: {
            moduleBridgeHex,
            view,
            page: 1,
            filtersHex: hexCode,
          },
        })
      ),
    [moduleBridgeHex, view]
  );

  // > GENERATE FILTER HEX CODE
  const generateFilterHexCode = useCallback(
    async (isParent = true) =>
      axios
        .post(
          axiosPath(
            'api_r_user_module_correctiveActions_task_list_generateFilterHexCodeForDependency'
          ),
          { moduleBridgeHex, taskID, isParent }
        )
        .then(({ data }) => goToEvaluation(data?.hexCode)),
    [moduleBridgeHex, view, taskID]
  );

  return (
    <>
      <AttatchedFile files={level1?.[taskID]?.files} />
      <CloseRequest hasCloseRequest={level2?.[taskID]?.hasCloseRequest} />
      <ParentTask
        hasParent={level2?.[taskID]?.hasParent}
        onClick={() => generateFilterHexCode(false)}
      />
      <ChildrenTask
        hasChildren={level2?.[taskID]?.hasChildren}
        onClick={generateFilterHexCode}
      />
      <Actions hasActions={level2?.[taskID]?.hasActions} />
    </>
  );
}
